/**
 * author andre.pitombeira
 */
import * as angular from 'angular';

import 'jquery';
import 'jquery-ui-dist/jquery-ui.min.js';
import 'bootstrap';

import 'angular-animate';
import 'angular-cookies';
import 'angular-resource';
import 'angular-sanitize';
import 'angular-touch';

import 'angular-ui-router';
import 'ngstorage';
import ColorThief from 'colorthief';
// Angular ui utils had issues and needs single module import
import 'angular-ui-utils/modules/utils';
import 'angular-ui-utils/modules/event/event';
import 'angular-ui-utils/modules/format/format';
import 'angular-ui-utils/modules/highlight/highlight';
import 'angular-ui-utils/modules/include/include';
import 'angular-ui-utils/modules/indeterminate/indeterminate';
import 'angular-ui-utils/modules/inflector/inflector';
import 'angular-ui-utils/modules/keypress/keypress';
import 'angular-ui-utils/modules/mask/mask';
import 'angular-ui-utils/modules/reset/reset';
import 'angular-ui-utils/modules/route/route';
import 'angular-ui-utils/modules/scrollfix/scrollfix';
import 'angular-ui-utils/modules/scroll/scroll';
import 'angular-ui-utils/modules/scroll/scroll-jqlite';
import 'angular-ui-utils/modules/showhide/showhide';
import 'angular-ui-utils/modules/unique/unique';
import 'angular-ui-utils/modules/validate/validate';

import 'angular-ui-bootstrap';
import 'oclazyload';
import 'angular-translate';
import 'angular-translate-loader-static-files';
import 'angular-translate-storage-cookie';
import 'angular-translate-storage-local';
import 'toastr';

import './vendor/ec-fe-bo-template/dist/angulr/angulr.js';
import './vendor/ec-fe-bo-template/dist/authentication/authentication.max.js';
import './vendor/ec-fe-bo-template/dist/ui/ui.max.js';
import './vendor/ec-fe-bo-template/dist/util/util.max.js';
import './vendor/ec-fe-bo-template/dist/schema/schema.max.js';

import 'tv4';
import 'objectpath';
import 'angular-schema-form';
import 'angular-schema-form-bootstrap';
import 'angular-spectrum-colorpicker';
import 'angular-ui-sortable';

import 'bootstrap-daterangepicker';
import 'angular-daterangepicker';
import 'dropzone';
import 'ngdropzone';

import 'imports-loader?define=>false,exports=>{module: true}!../../node_modules/ng-img-crop-full-extended/compile/unminified/ng-img-crop.js';

import 'angular-bootstrap-lightbox';
import 'ngmap';
import 'angular-ivh-treeview';
import 'angular-uuid';
import 'imports-loader?define=>false,exports=>{exports: true}!angular-bootstrap-calendar';

import 'ngclipboard';
import 'rangy';
import 'textangular';
import 'textangular/dist/textAngular-sanitize.min';
import './content-editor/custom-textAngular-sanitize.js';

import 'angular-file-upload';
import 'zeroclipboard';
import 'clipboard';
import 'ng-tags-input';
import 'angular-filter';

////////////// styles
import 'ng-tags-input/build/ng-tags-input.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'animate.css/animate.css';
import 'font-awesome/css/font-awesome.min.css';
import 'simple-line-icons/css/simple-line-icons.css';
import 'toastr/build/toastr.min.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import 'ng-img-crop-full-extended/compile/minified/ng-img-crop.css';
import 'angular-bootstrap-lightbox/dist/angular-bootstrap-lightbox.css';
import 'angular-ivh-treeview/dist/ivh-treeview.css';
import 'angular-ivh-treeview/dist/ivh-treeview-theme-basic.css';
import 'textangular/dist/textAngular.css';
import 'angular-bootstrap-calendar/dist/css/angular-bootstrap-calendar.min.css';
import 'ng2-dnd/bundles/style.css';
import '../main.less';

// Load base app related parts
import apiInterceptor from './apiInterceptor.interceptor';
import appRouter from './app.router';
import runBlock from './app.run';
import appConfig from './app.config';
import { AppController } from './app.controller';
import {
  API_V2_HEADER,
  API_V3_HEADER,
  API_V4_HEADER,
  AUTHENTICATION, BC_API,
  DESTINATION_TYPES,
  ENVIRONMENT,
  FILES_TYPES,
  IMAGES,
  INSTANCE_IDS,
  MERCHANT_PRODUCTS,
  MERCHANT_PRODUCTS_WITH_SWITCH_TO_BA_ENABLED,
  MERCHANT_PRODUCTS_WITH_SWITCH_TO_ENABLED,
  OC_API,
  OPTIONS,
  RESOURCES,
  SEARCH_TAGS_TYPES,
  SWITCH_TO_BA_CONFIG,
  SWITCH_TO_BC_CONFIG,
  SWITCH_TO_HOST_CONFIG,
  SWITCH_TO_RMA_CONFIG,
  TIMES,
  USER_TYPES,
  WEEKDAYS,
} from './app.constants';

// Load app modules
import contentEditModule from './content-editor/content-editor.module';
import chainsModule from './chains/chains.module.ajs';
import importModule from './merchants/importing/import.module.ajs';
import revertStatusModule from './merchants/revert-status/revert-status.module.ajs';
import customersModule from './customers/customers.module';
import destinationsModule from './destinations/destinations.module';
import imagesModule from './images/images.module';
import redemptionsModule from './redemptions/redemptions.module';
import reviewsModule from './reviews/reviews.module';
import seoModule from './seo/seo.module.ajs';
import covid19Module from './ops-support/covid-19/covid-19.module.ajs';
import bulkSettingsModule from './ops-support/settings/bulk-settings.module.ajs';
import sponsorsModule from './sponsors/sponsors.module';
import usersModule from './users/users.module';
import merchantsModule from './merchants/merchants.module.ajs';
import commonModule from './common/common.module.ajs';
import tagsModule from './tags/tags.module.ajs';
import webhooksModule from './webhooks/webhooks.module';
import { UirouterMigrationService } from 'OpsCenter/common/services/util/uirouter.migration.service';
import { downgradeInjectable } from '@angular/upgrade/static';
import merchantCleanUpModule from './ops-support/merchant-clean-up/merchant-clean-up.module.ajs';
import agentsModule from './agents/agents.module.ajs';
import { merchantToolsModule } from 'OpsCenter/merchant-tools/merchant-tools.module.ajs';
import merchantBulkCreate from 'OpsCenter/ops-support/merchant-bulk-create/merchant-bulk-create.module.ajs';
import loyaltyPointsModule from 'OpsCenter/ops-support/loyalty-points/loyalty-points.module.ajs';
window.ColorThief = ColorThief;
export const angularJsModule = angular
  .module('ec.opsCenter', [
    'ec.angulr',
    'ec.authentication',
    'ec.ui',
    'ec.util',
    'ec.schema',
    'ui.sortable',
    'daterangepicker',
    'thatisuday.dropzone',
    'ngImgCrop',
    'bootstrapLightbox',
    'ngMap',
    'ivh.treeview',
    'angular-uuid',
    'mwl.calendar',
    'ngclipboard',
    'textAngular',
    'angularFileUpload',
    'angular.filter',
    commonModule,
    contentEditModule,
    chainsModule,
    customersModule,
    importModule,
    revertStatusModule,
    destinationsModule,
    imagesModule,
    redemptionsModule,
    reviewsModule,
    seoModule,
    bulkSettingsModule,
    merchantCleanUpModule,
    covid19Module,
    loyaltyPointsModule,
    sponsorsModule,
    usersModule,
    merchantsModule,
    tagsModule,
    tagsModule,
    webhooksModule,
    merchantToolsModule,
    agentsModule,
    merchantBulkCreate,
  ])
  .config(appConfig)
  .config(appRouter)
  .factory('apiInterceptor', apiInterceptor)
  .factory('uirouterMigrationService', downgradeInjectable(UirouterMigrationService))
  .constant('OC_API', OC_API)
  .constant('BC_API', BC_API)
  .constant('API_V2_HEADER', API_V2_HEADER)
  .constant('API_V3_HEADER', API_V3_HEADER)
  .constant('API_V4_HEADER', API_V4_HEADER)
  .constant('SWITCH_TO_BC_CONFIG', SWITCH_TO_BC_CONFIG)
  .constant('SWITCH_TO_BA_CONFIG', SWITCH_TO_BA_CONFIG)
  .constant('SWITCH_TO_RMA_CONFIG', SWITCH_TO_RMA_CONFIG)
  .constant('SWITCH_TO_HOST_CONFIG', SWITCH_TO_HOST_CONFIG)
  .constant('ENVIRONMENT', ENVIRONMENT)
  .constant('INSTANCE_IDS', INSTANCE_IDS)
  .constant('OPTIONS', OPTIONS)
  .constant('USER_TYPES', USER_TYPES)
  .constant('DESTINATION_TYPES', DESTINATION_TYPES)
  .constant('RESOURCES', RESOURCES)
  .constant('MERCHANT_PRODUCTS', MERCHANT_PRODUCTS)
  .constant('MERCHANT_PRODUCTS_WITH_SWITCH_TO_ENABLED', MERCHANT_PRODUCTS_WITH_SWITCH_TO_ENABLED)
  .constant('MERCHANT_PRODUCTS_WITH_SWITCH_TO_BA_ENABLED', MERCHANT_PRODUCTS_WITH_SWITCH_TO_BA_ENABLED)
  .constant('WEEKDAYS', WEEKDAYS)
  .constant('TIMES', TIMES)
  .constant('AUTHENTICATION', AUTHENTICATION)
  .constant('IMAGES', IMAGES)
  .constant('FILES_TYPES', FILES_TYPES)
  .constant('SEARCH_TAGS_TYPES', SEARCH_TAGS_TYPES)
  .controller('AppController', AppController)
  .run(runBlock);




// WEBPACK FOOTER //
// ./src/app/app.angularjs.module.js